import React from "react";
import "./Cars.css"; // Import CSS
import dzireImg from "../assets/wallpapers/dzire.jpg";
import ertigaImg from "../assets/wallpapers/ertiga.jpg";
import innovaImg from "../assets/wallpapers/Innova_v1.jpg";

export default function Cars() {
  const cars = [
    { 
     name: "Dzire",
     desc: " Perfect for city and outstation trips with great mileage.",
     img: dzireImg, 
     price: "₹10 / km"
    },
    {
      name: "Ertiga",
      desc: "Spacious and comfortable for family or group travel.",
      img: ertigaImg,
      price: "₹12 / km"
    },
    {
      name: "Crysta",
      desc: "Luxury, space, and reliability for long journeys.",
      img: innovaImg,
      price: "₹13 / km"
    }
  ];

  return (
    <div className="cars-section">
      <h2 className="section-title">Our Cars</h2>
      <div className="cars-container">
        {cars.map((car, index) => (
          <div key={index} className="car-card">
            <div className="car-img-wrapper">
              <img src={car.img} alt={car.name} className="car-img" />
            </div>
            <h3>{car.name}</h3>
            <h4><strong>{car.desc}</strong></h4>
            <h2>{car.price}</h2>
          </div>
        ))}
      </div>
    </div>
  );
}
